var SCM = SCM || {};

// WARNING: This module must be "widget instance safe". All selectors must be relative to the clicked node.
// This is because there can be multiple instances of the widget.
(function (ns, $) {

    var maxLevel = $('#hfMaxRelativeDepth').length ? parseInt($('#hfMaxRelativeDepth').val()) : 0;
    var browseContentInLinkText = $('#hfBrowseContentInLinkText').val();
    var _transitionLength = 100;

    function _nodeGreaterThanMaxLevel() {
        var $this = $(this);    // Item in the list of all nodes
        return parseInt($this.attr('data-level')) > maxLevel;
    }

    function goDeeper() {
        var $this = $(this);
        var $currentNode = $this.closest('.js-tree-node-item');
        var $context = $currentNode.closest('.js-tree-browse-wrap');
        var currentLevel = $currentNode.attr('data-level');
        var newRootNode = $currentNode.attr('data-id');
        var $additionalNodes = null;

        // If we're at the max level, show any nodes that are deeper.
        if (currentLevel === maxLevel) {
            $additionalNodes = $currentNode.next('.js-children').find('.js-tree-node-item').filter(_nodeGreaterThanMaxLevel);
        }

        changeLevelOfNodesDisplayed($context, newRootNode, $additionalNodes);

        setTimeout(function () {
            updateBreadcrumbsToGoDeeper($context, $currentNode, newRootNode);
        }, _transitionLength);

        updateBrowseLink($context, $currentNode);
    }

    /// Animation Step (Start)
    function changeLevelOfNodesDisplayed($context, newRootNode, $additionalNodes) {
        // Set to show only those specified
        var $nodesToShow = $context.find('.js-tree-node-item[data-parent-id="' + newRootNode + '"]');
        if ($additionalNodes && $additionalNodes.length) {
            $nodesToShow = $nodesToShow.add($additionalNodes);
        }

        // Reset all nodes
        var $allNodes = $context.find('.js-tree-node-item');
        $allNodes.removeClass('fade');
        var originalTotalHeight = $context.find('.js-tree-browse-nodes-wrap').height();
        $context.find('.js-tree-browse-nodes-wrap').height(originalTotalHeight);

        hideAllNodes($allNodes)
            .then(function(originalHeight) {
                return activateNewNodes($context, $nodesToShow, originalHeight);
            })
            .then(function() {
                return fadeInNodes($nodesToShow);
            });
    }

    /// Animation Step
    function hideAllNodes($allNodes) {
        return new Promise(function (resolve) {
            setTimeout(function () {
                $allNodes.removeClass('active');
                resolve();
            }, _transitionLength);
        });
    }

    /// Animation Step
    function updateBreadcrumbsToGoDeeper($context, $currentNode, newRootNode) {
        return new Promise(function(resolve) {
            // You clicked on a node with an arrow. Add it to the breadcrumbs.
            var currentNodeLabel = $currentNode.find('.js-tree-node-link').text();
            var $breadcrumbs = $context.find('.js-tree-browse-breadcrumb-link');

            // Reveal the breadcrumbs if we haven't already
            var $breadcrumbWrapWrap = $breadcrumbs.closest('.js-tree-browse-breadcrumb-wrap');
            var $breadcrumbWrap = $breadcrumbs.closest('.js-breadcrumbs');

            if (!$breadcrumbWrap.is('.active')) {
                $breadcrumbWrapWrap.height(0);
            }
            
            $breadcrumbWrap.addClass('active');
            $breadcrumbWrap.addClass('fade');

            setTimeout(function () {
                $breadcrumbWrapWrap.height($breadcrumbs.closest('.js-breadcrumbs').outerHeight());
            }, _transitionLength);

            $breadcrumbs.removeClass('active');
            var $nextEmptyBreadcrumb = $breadcrumbs.siblings('.hide').first();
            $nextEmptyBreadcrumb.text(currentNodeLabel);
            $nextEmptyBreadcrumb.attr('data-id', newRootNode);
            $nextEmptyBreadcrumb.removeClass('hide');
            $nextEmptyBreadcrumb.addClass('active');
            resolve();
        });
    }

    /// Animation Step
    function activateNewNodes($context, $nodesToShow) {
        return new Promise(function(resolve) {
            setTimeout(function() {
                $nodesToShow.addClass('active');
                var newNodesHeight = $context.find('.js-tree-browse-nodes').outerHeight();
                $context.find('.js-tree-browse-nodes-wrap').height(newNodesHeight);
                resolve();
            },
            _transitionLength);
        });
    }

    /// Animation Step
    function fadeInNodes($nodesToShow) {
        return new Promise(function(resolve) {
            setTimeout(function() {
                $nodesToShow.addClass('fade');
                resolve();
            },
            _transitionLength);
        });
    }

    /// Animation Step
    function updateBrowseLink($context, $currentNode) {
        var currentNodeLabel = $currentNode.find('.js-tree-node-link').text();
        var newRootNode = $currentNode.attr('data-id');

        return new Promise(function(resolve) {
            setTimeout(function() {
                $context.find('.js-tree-browse-link-all').addClass('hide');
                var $narrowLink = $context.find('.js-tree-browse-link-narrowed');
                $narrowLink.text(browseContentInLinkText + currentNodeLabel);
                $narrowLink.attr('href', $narrowLink.data('href-template').concat(newRootNode));
                $narrowLink.removeClass('hide');
                resolve();
            },
            _transitionLength);
        });
    }

    function breadcrumbClick() {
        var $this = $(this);
        var $context = $this.closest('.js-tree-browse-wrap');
        $this.nextAll().addClass('hide');
        $this.addClass('active');
        var newId = $this.attr('data-id');
        changeLevelOfNodesDisplayed($context, newId);

        // If you clicked the root breadcrumb, hide all breadcrumbs.
        if ($this.is('.js-root-breadcrumb')) {
            var $breadcrumbsWrap = $this.parents('.js-breadcrumbs');
            $breadcrumbsWrap.removeClass('fade');
            $breadcrumbsWrap.closest('.js-tree-browse-breadcrumb-wrap').height(0);
            setTimeout(function () {
                $breadcrumbsWrap.removeClass('active');
            }, _transitionLength);

            // Change the "Browse content in ..." link to "Browse all content"
            $context.find('.js-tree-browse-link-all').removeClass('hide');
            $context.find('.js-tree-browse-link-narrowed').addClass('hide');
        } else {
            var currentNodeLabel = $context
                .find('.js-tree-node-item[data-id="' + newId + '"]')
                .find('.js-tree-node-link')
                .text();
            var $narrowLink = $context.find('.js-tree-browse-link-narrowed');
            $narrowLink.text(browseContentInLinkText + currentNodeLabel);
            $narrowLink.attr('href', $narrowLink.data('href-template').concat(newId));
            $narrowLink.removeClass('hide');
        }
    }

    ns.checkPageHeightForSeriesDropdown = function () {
        var $contentPanel = $('.js-main');
        if ($('#searchResultsPage').length !== 0) {
            $contentPanel = $('#ContentColumn');
        }
        if ($contentPanel.length > 0) {
            var contentHeight = $contentPanel.height();
            var maxHeight = contentHeight;
            var $treeDropdowns = $('.js-tree-browse-wrap');
            $treeDropdowns.each(function () {
                var treeHeight = $(this).height();
                if (treeHeight > maxHeight) {
                    maxHeight = treeHeight;
                }
            });
            if (maxHeight > contentHeight) {
                $contentPanel.height(maxHeight);
            }
        }
    };

    // Called by the main init in client.script.js. This handles all instances. The other functions must be "widget instance safe".
    ns.init = function () {
        $(document.body).on('click', '.js-tree-node-link', goDeeper);
        $(document.body).on('click', '.js-tree-browse-breadcrumb-link', breadcrumbClick);
        ns.checkPageHeightForSeriesDropdown();
    };

})(SCM.TreeBrowse = SCM.TreeBrowse || {}, jQuery);
